import { Component } from 'react';
import { connect } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { Tab, Tabs } from 'foundations-components/transitional/components/Tabs';
import { ToolBar } from 'foundations-components/transitional/components/ToolBar';
import { ToolBarGroup } from 'foundations-components/transitional/components/ToolBarGroup';
import { Text } from 'foundations-components/components/Text';
import { CATEGORIZE_STEP, WRITE_STEP } from '../../constants/edit/StepsConstants';
import { SCREENS } from '../../constants/TrackingConstants';
import { validateArticleState } from '../../utils/editUtils';
import { getLivePreviewHref } from '../../utils/previewUtils';
import UsageTracker from '../../utils/UsageTracker';
import ArticleHeaderBadges from '../ArticleHeaderBadges';
import { selectSiteSettingsFetched } from '../../selectors/siteSettings';
import { selectHasSiteSettingsAccess } from '../../selectors/scopes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class EditSubHeader extends Component {
  constructor(...args) {
    super(...args);
    this.handleStepChange = ({
      target: {
        value
      }
    }) => {
      this.props.onStepChange(value);
    };
    this.handlePreviewClick = subscreen => {
      UsageTracker.track('createArticleInteraction', {
        screen: SCREENS.CREATE,
        subscreen,
        action: 'preview'
      });
    };
  }
  renderPreviewLink() {
    const {
      article,
      selectedStep
    } = this.props;
    return /*#__PURE__*/_jsx(ToolBarGroup, {
      children: /*#__PURE__*/_jsx(Link, {
        external: true,
        href: getLivePreviewHref(article),
        onClick: () => this.handlePreviewClick(selectedStep),
        paddingInlineEnd: "800",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "knowledgeContentUI.shared.actions.preview"
        })
      })
    });
  }
  renderTab(step, errors, dataTestId) {
    return /*#__PURE__*/_jsx(Tab, {
      "data-test-id": dataTestId,
      tabId: step,
      title: /*#__PURE__*/_jsx(Text, {
        as: "span",
        typography: "body-100",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `knowledgeContentUI.edit.tabs.${step}`
        })
      })
    });
  }
  renderHeaderBadges() {
    const {
      article,
      hasSiteSettingsAccess,
      siteSettingsFetched
    } = this.props;
    if (hasSiteSettingsAccess && !siteSettingsFetched) {
      return null;
    }

    // @bend-expect trellis-tokenized
    return /*#__PURE__*/_jsx(ArticleHeaderBadges, {
      articleState: article.values.hs_state,
      archived: article.values.hs_archived_in_dashboard === 1,
      accessRuleIds: article.values.hs_access_rule_ids,
      accessRuleType: article.values.hs_access_rule_type,
      marginBlockStart: "200"
    });
  }
  render() {
    const {
      article,
      customSlugEnding,
      noSelectedListError,
      noSelectedAccessGroupError,
      selectedCategoryId,
      selectedStep
    } = this.props;

    // @ts-expect-error ts-migrate(2554) FIXME: Expected 8 arguments, but got 4.
    const {
      errors
    } = validateArticleState(customSlugEnding, noSelectedListError, noSelectedAccessGroupError, selectedCategoryId, article);
    return /*#__PURE__*/_jsxs(ToolBar, {
      use: "tabs",
      children: [/*#__PURE__*/_jsx(ToolBarGroup, {
        children: this.renderHeaderBadges()
      }), /*#__PURE__*/_jsx(ToolBarGroup, {
        children: /*#__PURE__*/_jsxs(Tabs, {
          onSelectedChange: this.handleStepChange,
          selected: selectedStep,
          children: [this.renderTab(WRITE_STEP, errors, 'editor-tab-write'), this.renderTab(CATEGORIZE_STEP, errors, 'editor-tab-categorize')]
        })
      }), this.renderPreviewLink()]
    });
  }
}
const mapStateToProps = state => ({
  siteSettingsFetched: selectSiteSettingsFetched(state),
  hasSiteSettingsAccess: selectHasSiteSettingsAccess(state)
});
export default connect(mapStateToProps)(EditSubHeader);